import store from '@/store'

const routes = [{
    path: '/operations/inbound/:id',
    name: 'warehouseinbound',
    component: () => import('@/views/main/modules/Operations/Inbound/InboundGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Inbound',
    },
}]

export default routes;
